import React, { useEffect, useState } from 'react'
import { Grid, Box, Button, useTheme, IconButton, Divider } from '@mui/material'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import jsPDF from 'jspdf'
import moment from 'moment'
import autoTable from 'jspdf-autotable'
import DispatchMiddSection1 from './DispatchMiddSection1'
import DispatchMiddSection2 from './DispatchMiddSection2'
import DispatchMiddSection3 from './DispatchMiddSection3'
import DispatchMiddSection4 from './DispatchMiddSection4'
import DispatchMiddSection5 from './DispatchMiddSection5'
import DispatchMiddSection6 from './DispatchMiddSection6'
import DispatchMiddSection7 from './DispatchMiddSection7'
import DispatchMiddSection8 from './DispatchMiddSection8'
import DispatchMiddSection9 from './DispatchMiddSection9'
import AppsIcon from '@mui/icons-material/Apps'
import PrintIcon from '@mui/icons-material/Print'
import PdfIcon from '@mui/icons-material/PictureAsPdf'
import ExcelIcon from '@mui/icons-material/FileCopy'
import { updateModal } from '../../../../store/common/common_action'
import { connect, useSelector } from 'react-redux'
import LastPageIcon from '@mui/icons-material/LastPage'
import PropTypes from 'prop-types'
import FirstPageIcon from '@mui/icons-material/FirstPage'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import { calculateDynamicFormatLandscape, calculateDynamicFormatPortrait, calculateTotalTableWidth, clickElement, focusElemnt, getAutoTableColumns, navigation3 } from '../../../common/helper'
import { transparentStyle } from '../../DeliveryMemo/const'
import {
  BranchSummaryLargePdf,
  ShowOnlyToPayAmountDetailedLargePdf,
  VehicleWiseDispatchDetailedLargePdf,
  WithHamaliAndChartageSummaryLargePdf,
  WithOtherChargeSummaryLargePdf,
  WithPaymentTypeGroupLargePdf,
  WithVehicleAndChartDateDetailedLargePdf,
  WithVehicleAndChartDateSummaryLargePdf,
} from './LargePDF'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal'
import { coloumnDispatchDetails1, getVehicleAndChartDateSummaryColumns, getVehicleWithDispatchSummaryColumn, getWithHamaliAndCartageSummaryColumn, headerColumnChallanWiseDispatchSummaryColumn } from '../common/reportConstants'
import DispatchMiddSection10 from './DispatchMiddSection10'
import WithOtherCharges from './Detailed/WithOtherCharges'
import { getWithOtherChargesColumn } from './Constant'

const DispatchReportTable = ({
  loginData = { loginData },
  tableindex = 0,
  reportType,
  data,
  updateModal,
  detailedFilter,
  showSummaryReport,
  dispatchDetailsTableData,
  challanWiseDispatchTableData,
  dispatchSummaryTableData,
  DispatchMemoDetailTableData,
  selFromBranch,
  selDestCity,
  selBranch,
  selPaymentTpe,
  selVehicle,
  toDate,
  fromDate,
  paymentWiseTotal,
  paymentSummary,
  paymentWiseVehicleData,
  groupDataSecond,
  manageColumn,
  headerData,
  disableExcel
}) => {
  
  const [tableData, setTableData] = useState([])
  const { common } = data
  const theme = useTheme()
  const { showModal, modalType } = common
  const [showTable, setShowTable] = useState(true)
  const companySettings = useSelector((state) => state?.common?.companySettings[0])
  const UseToPayAsCOD=companySettings[0]?.UseToPayAsCOD
  const loginCountryId = companySettings?.DefaultCurrencyID;
  const [state, setState] = useState({
    // ListData:[],
    startIndex: 0,
    lastIndex: 8,
    Total: 0,
    TotalAmount: 0,
    generatePDF: false,
    load: false,
  })
  const { startIndex, lastIndex } = state
  const { generatePDF, load } = state
  const selectedFields = manageColumn.filter((item) => item.isSelected).reduce((result, item) => ({ ...result, [item.field]: true }), {})
  const [largePDF, setLargePDF] = useState(false)
  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
  const generatepdf = (isSave) => {
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
    const HeaderColumn = [
      {
        headerName: 'Dispatch By Branch',
        exportHead: 'Dispatch By Branch',
        field: 'selFromBranch',
        xlCol: { dataType: 'string', dataFormatter: null },
      },

      {
        headerName: 'Destination City',
        exportHead: 'Destination City',
        field: 'selDestCity',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Destination Branch',
        exportHead: 'Destination Branch',
        field: 'selBranch',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Vehicle Number',
        exportHead: 'Vehicle Number',
        field: 'selVehicle',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Payment Type',
        exportHead: 'Payment Type',
        field: 'selPaymentTpe',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Report Type',
        exportHead: 'Report Type',
        field: 'reportType',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Report View',
        exportHead: 'Report View',
        field: 'showSummaryReport',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Report Option',
        exportHead: 'Report Option',
        field: 'detailedFilter',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
    ]
    const paymetDetailedColumn = [
      {
        headerName: 'SN ',
        exportHead: 'SN ',
        field: 'SN',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'LRNo\nChl. No\nMan. LR No',
        exportHead: 'LRNo\nChl. No\nMan. LR No',
        field: 'OnlyLRNo',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Veh.\nNo',
        exportHead: 'Veh.\nNo',
        field: 'VoucherNo',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Disp. \nDate & Time',
        exportHead: 'Disp. \nDate & Time',
        field: 'DispatchDateTime',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Src.\nCity',
        exportHead: 'Src.\nCity',
        field: 'BookCity',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Dest.\nCity',
        exportHead: 'Dest.\nCity',
        field: 'ToCity',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Disp. To\nCity',
        exportHead: 'Disp. To\nCity',
        field: 'FromCityName',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Disp. To \nBranch',
        exportHead: 'Disp. To \nBranch',
        field: 'DispatchedToCity',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Sender \nDetails',
        exportHead: 'Sender \nDetails',
        field: 'senderDetailes',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Rec. \nDetails',
        exportHead: 'Rec. \nDetails',
        field: 'receiverDetailes',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Item\nDetails',
        exportHead: 'Item\nDetails',
        field: 'ItemDetails',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'unit',
        exportHead: 'unit',
        field: 'Quantity',
        xlCol: { dataType: 'quantity', dataFormatter: null },
      },
      {
        headerName: 'Frgt.\nChrg.',
        exportHead: 'Frgt.\nChrg.',
        field: 'Freight',
        xlCol: { dataType: 'quantity', dataFormatter: null },
      },
      {
        headerName: 'Ham.\nChrg.',
        exportHead: 'Ham.\nChrg.',
        field: 'HamaliCharges',
        xlCol: { dataType: 'quantity', dataFormatter: null },
      },
      {
        headerName: 'Cart.\nChrg.',
        exportHead: 'Cart.\nChrg.',
        field: 'CartageAmount',
        xlCol: { dataType: 'quantity', dataFormatter: null },
      },
      {
        headerName: loginCountryId === 2 ? 'Insu. \nChrg.' : 'Val. \nChrg.',
        exportHead: loginCountryId === 2 ? 'Insu. \nChrg.' : 'Val. \nChrg.',
        field: 'Insurance',
        xlCol: { dataType: 'quantity', dataFormatter: null },
      },
      {
        headerName: 'Oth.\nChrg.',
        exportHead: 'Oth.\nChrg.',
        field: 'AllOther',
        xlCol: { dataType: 'quantity', dataFormatter: null },
      },
      {
        headerName: 'Net\nAmt.',
        exportHead: 'Net\nAmt.',
        field: 'NetAmount',
        xlCol: { dataType: 'quantity', dataFormatter: null },
      },
    ]
    const showOnlyToPayAmountDetailedColumn = [
      {
        headerName: 'LR \nNo.',
        exportHead: 'LR \nNo.',
        field: 'LRNO',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Sender \nName',
        exportHead: 'Sender \nName',
        field: 'SenderName',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Sender \nGSTIN',
        exportHead: 'Sender \nGSTIN',
        field: 'SenderGSTN',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Receiver \nName',
        exportHead: 'Receiver \nName',
        field: 'RecName',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Receiver \nGSTIN',
        exportHead: 'Receiver \nGSTIN',
        field: 'ReceiverGSTN',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'No. of \nParcels',
        exportHead: 'No. of \nParcels',
        field: 'Quantity',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'Goods \nDescription',
        exportHead: 'Goods \nDescription',
        field: 'ItemDetails',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Payment \nType',
        exportHead: 'Payment \nType',
        field: 'PaymentType',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Total \nAmount',
        exportHead: 'Total \nAmount',
        field: 'NetAmount',
        xlCol: { dataType: 'quantity', dataFormatter: null },
      },
      {
        headerName: 'Remarks',
        exportHead: 'Remarks',
        field: 'Remarks',
        xlCol: { dataType: 'quantity', dataFormatter: null },
      },
    ]
    const showOnlyToPayAmountSummaryColumn = [
      {
        headerName: 'Veh.\nNo',
        exportHead: 'Veh.\nNo',
        field: 'vehicleNo',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Paid \nUnit',
        exportHead: 'Paid \nUnit',
        field: 'paidQuantity',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'Paid \nAmt.',
        exportHead: 'Paid \nAmt.',
        field: 'paidAmount',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'Topay \nUnit',
        exportHead: 'Topay \nUnit',
        field: 'toPayQuantity',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'Topay \nAmt.',
        exportHead: 'Topay \nAmt.',
        field: 'toPayAmount',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'FOC \nUnit',
        exportHead: 'FOC \nUnit',
        field: 'fOCQuantity',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'FOC \nAmt.',
        exportHead: 'FOC \nAmt.',
        field: 'fOCAmount',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'COD \nUnit',
        exportHead: 'COD \nUnit',
        field: 'cODQuantity',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'COD \nAmt.',
        exportHead: 'COD \nAmt.',
        field: 'cODAmount',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'OnAct \nUnit',
        exportHead: 'OnAct \nUnit',
        field: 'onAccountQuantity',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'OnAct \nAmt.',
        exportHead: 'OnAct \nAmt.',
        field: 'onAccountAmount',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'PaidMan.\nUnit',
        exportHead: 'PaidMan.\nUnit',
        field: 'paid(Manual)Quantity',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'PaidMan.\nAmt.',
        exportHead: 'PaidMan.\nAmt.',
        field: 'paid(Manual)Amount',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'TopayMan.\nUnit',
        exportHead: 'TopayMan.\nUnit',
        field: 'toPay(Manual)Quantity',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'TopayMan.\nAmt.',
        exportHead: 'TopayMan.\nAmt.',
        field: 'toPay(Manual)Amount',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'SelfBkg.\nUnit',
        exportHead: 'SelfBkg.\nUnit',
        field: 'selfQuantity',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'SelfBkg.\nAmt.',
        exportHead: 'SelfBkg.\nAmt.',
        field: 'selfAmount',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'OnActMan.\nUnit',
        exportHead: 'OnActMan.\nUnit',
        field: 'onAccount(Manual)Quantity',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'OnActMan.\nAmt.',
        exportHead: 'OnActMan.\nAmt.',
        field: 'onAccount(Manual)Amount',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'Total\nUnits',
        exportHead: 'Total\nUnits',
        field: 'totalUnits',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'Total\nAmt',
        exportHead: 'Total\nAmt',
        field: 'totalAmount',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
    ]
    const withHamaliAndCartageSummaryColumn=getWithHamaliAndCartageSummaryColumn(loginCountryId,UseToPayAsCOD)
    const summaryColumn = [
      {
        headerName: 'Payment Type',
        exportHead: 'Payment Type',
        field: 'PaymentType',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Item Type (Quantity)',
        exportHead: 'Item Type (Quantity)',
        field: 'Quantity',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'Freight',
        exportHead: 'Freight',
        field: 'Freight',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'Doc Charge',
        exportHead: 'Doc Charge',
        field: 'DocumentCharges',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'Cartage',
        exportHead: 'Cartage',
        field: 'CartageAmount',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'Hamali',
        exportHead: 'Hamali',
        field: 'HamaliCharges',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'Operator Hamali',
        exportHead: 'Operator Hamali',
        field: 'OperatorHamaliChg',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      loginCountryId!==2 && {
        headerName: 'Freight GST',
        exportHead: 'Freight GST',
        field: 'ServiceTaxAmount',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      loginCountryId!==2 && {
        headerName: 'Cartage GST',
        exportHead: 'Cartage GST',
        field: 'CartageTax',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      loginCountryId!==2 && {
        headerName: 'Hml+Op.HmlGST',
        exportHead: 'Hml+Op.HmlGST',
        field: 'OptHamaliGST',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: loginCountryId===2?'Insurance Charge':'Valuation Charge',
        exportHead: loginCountryId===2?'Insurance Charge':'Valuation Charge',
        field: 'Insurance',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'Total',
        exportHead: 'Total',
        field: 'NetAmount',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
    ]
    const vihicleAndChartDatesummaryColumn = [
      {
        headerName: 'Veh. \nNo.',
        exportHead: 'Veh. \nNo.',
        field: 'VehicleNo',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Disp. \nCity',
        exportHead: 'Disp. \nCity',
        field: 'SummaryFromCity',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Rec. \nCity',
        exportHead: 'Rec. \nCity',
        field: 'SummaryToCity',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Topay \nCodCount',
        exportHead: 'Topay \nCodCount',
        field: 'topayCount',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'Paid \nCount',
        exportHead: 'Paid \nCount',
        field: 'paidCount',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'OnAct. \nCount',
        exportHead: 'OnAct. \nCount',
        field: 'onAccountCount',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'FOCSelf \nCount',
        exportHead: 'FOCSelf \nCount',
        field: 'focCount',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'DDDV \nCount',
        exportHead: 'DDDV \nCount',
        field: 'topaydddvCount',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'Total \nCount',
        exportHead: 'Total \nCount',
        field: 'total',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'Total \nUnit',
        exportHead: 'Total \nUnit',
        field: 'totalQuantity',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'TopayCod \nFrgt.',
        exportHead: 'TopayCod \nFrgt.',
        field: 'ToPayCodFreight',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'Paid \nFrgt.',
        exportHead: 'Paid \nFrgt.',
        field: 'paidFreight',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'OnAct. \nFrgt.',
        exportHead: 'OnAct. \nFrgt.',
        field: 'OnAccountFreight',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'FOCSelf \nFrgt.',
        exportHead: 'FOCSelf \nFrgt.',
        field: 'FocFreight',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'DDDV \nFrgt.',
        exportHead: 'DDDV \nFrgt.',
        field: 'DddvFreight',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'Total \nFrgt.',
        exportHead: 'Total \nFrgt.',
        field: 'totalFreight',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'TopayCod \nGstOth.',
        exportHead: 'TopayCod \nGstOth.',
        field: 'ToPayCodGstOther',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'Paid \nGstOth.',
        exportHead: 'Paid \nGstOth.',
        field: 'paidGstOther',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'OnAccount \nGstOth.',
        exportHead: 'OnAccount \nGstOth.',
        field: 'OnAccountGstOther',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'FOCSelf \nGstOth.',
        exportHead: 'FOCSelf \nGstOth.',
        field: 'FocGstOther',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'DDDV \nGstOth.',
        exportHead: 'DDDV \nGstOth.',
        field: 'TopayDddvGstOther',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'Total \nGstOth.',
        exportHead: 'Total \nGstOth.',
        field: 'totalGstOther',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'Net \nAMT.',
        exportHead: 'Net \nAMT.',
        field: 'totalNetAmount',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'Disp. Date\nand Time',
        exportHead: 'Disp. Date\nand Time',
        field: 'DispatchDateTime',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Driver\nName',
        exportHead: 'Driver\nName',
        field: 'SummaryDriverConductorName',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
    ]
    const withOtherSummaryColumn = [
      {
        headerName: 'Veh. \nNo.',
        exportHead: 'Veh. \nNo.',
        field: 'BusNumber',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Drvr \nName',
        exportHead: 'Drvr \nName',
        field: 'DriverConductorName',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Disp. \nCity.',
        exportHead: 'Disp. \nCity.',
        field: 'Station',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: UseToPayAsCOD === 1 ? 'COD \nUnit' : 'Topay \nCodUnit',
        exportHead: UseToPayAsCOD === 1 ? 'COD \nUnit' : 'Topay \nCodUnit',
        field: 'TopayUnit',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'Paid \nUnit',
        exportHead: 'Paid \nUnit',
        field: 'PaidUnit',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'OnAcount \nUnit',
        exportHead: 'OnAcount \nUnit',
        field: 'OnAccountUnit',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'FOCSelf \nUnit',
        exportHead: 'FOCSelf \nUnit',
        field: 'FocAndSelfUnit',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'DDDV \nUnit',
        exportHead: 'DDDV \nUnit',
        field: 'DDDVUnit',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'Total \nUnit',
        exportHead: 'Total \nUnit',
        field: 'TotalUnits',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: UseToPayAsCOD === 1 ? 'COD \nFrgt.' : 'TopayCod \nFrgt.',
        exportHead: UseToPayAsCOD === 1 ? 'COD \nFrgt.' : 'TopayCod \nFrgt.',
        field: 'TopayFreight',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'Paid \nFrgt.',
        exportHead: 'Paid \nFrgt.',
        field: 'PaidFreight',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'OnAccount \nFrgt.',
        exportHead: 'OnAccount \nFrgt.',
        field: 'OnAccountFreight',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'FOCSelf \nFrgt.',
        exportHead: 'FOCSelf \nFrgt.',
        field: 'FocAndSelfFreight',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'DDDV \nFrgt.',
        exportHead: 'DDDV \nFrgt.',
        field: 'DDDVFreight',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'Total \nFrgt.',
        exportHead: 'Total \nFrgt.',
        field: 'TotalFreight',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: loginCountryId !== 2
          ? (UseToPayAsCOD === 1 ? 'COD \nGstOth.' : 'TopayCod \nGstOth.')
          : (UseToPayAsCOD === 1 ? 'COD \nOth.' : 'TopayCod \nOth.'),
        exportHead: loginCountryId !== 2
          ? (UseToPayAsCOD === 1 ? 'COD \nGstOth.' : 'TopayCod \nGstOth.')
          : (UseToPayAsCOD === 1 ? 'COD \nOth.' : 'TopayCod \nOth.'),
        field: 'TopayCodGstOth',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: loginCountryId!==2?'Paid \nGstOth.':'Paid \nOth.',
        exportHead: loginCountryId!==2?'Paid \nGstOth.':'Paid \nOth.',
        field: 'PaidGstOth',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: loginCountryId!==2?'OnAccount \nGstOth.':'OnAccount \nOth.',
        exportHead: loginCountryId!==2?'OnAccount \nGstOth.':'OnAccount \nOth.',
        field: 'OnActGstOth',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: loginCountryId!==2?'FOCSelf \nGstOth.':'FOCSelf \nOth.',
        exportHead: loginCountryId!==2?'FOCSelf \nGstOth.':'FOCSelf \nOth.',
        field: 'FOCSelfGstOth',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: loginCountryId!==2?'DDDV \nGstOth.':'DDDV \nOth.',
        exportHead: loginCountryId!==2?'DDDV \nGstOth.':'DDDV \nOth.',
        field: 'DDDVGstOth',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: loginCountryId!==2?'Net \nGstOth.':'Net \nOth.',
        exportHead: loginCountryId!==2?'Net \nGstOth.':'Net \nOth.',
        field: 'NetOther',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: loginCountryId === 2 ? 'Insu. \nChrg.' : 'Val. \nChrg.',
        exportHead: loginCountryId === 2 ? 'Insu. \nChrg.' : 'Val. \nChrg.',
        field: 'Insurance',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'Other \nChrg.',
        exportHead: 'Other \nChrg.',
        field: 'OtherCharge',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'Net \nLr.',
        exportHead: 'Net \nLr.',
        field: 'TotalLRCount',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'Net \nAmt.',
        exportHead: 'Net \nAmt.',
        field: 'TotalNetAmount',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
    ]
    const withOtherChargesColumn=getWithOtherChargesColumn(UseToPayAsCOD)
    const withVehicleAndChartDateSummaryColumn=getVehicleAndChartDateSummaryColumns(loginCountryId,UseToPayAsCOD)
    const HeaderColumns = HeaderColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    // const detailedColumns = coloumnDispatchDetails1.map((col) => {
    //   return { header: col.header, dataKey: col.field, xlCol: col.xlCol }
    // })
    const detailedColumns = manageColumn.filter((val) => val.isSelected).map((col) => {
      return { header: col.header, dataKey: col.field, xlCol: col.xlCol }
    })
    const summaryColumns = summaryColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const paymentDetailsCol = paymetDetailedColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol, headerSx: col.headerSx }
    })
    const showOnlyToPayAmountCol = showOnlyToPayAmountDetailedColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol, headerSx: col.headerSx }
    })
    const withHamaliAndCartageSummaryCol = withHamaliAndCartageSummaryColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol, headerSx: col.headerSx }
    })
    const withVehicleAndChartDateSummaryCol = withVehicleAndChartDateSummaryColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol, headerSx: col.headerSx }
    })
    const vihicleAndChartDatesummaryCol = vihicleAndChartDatesummaryColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const withOtherSummaryCol = withOtherSummaryColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol, headerSx: col.headerSx }
    })
    const withOtherChargesCol = withOtherChargesColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol, headerSx: col.headerSx }
    })
    // const withOtherChargesCol=[]
    const showOnlyToPayAmountSummaryCol = showOnlyToPayAmountSummaryColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol, headerSx: col.headerSx }
    })

    const HeaderData = [
      {
        selFromBranch: selFromBranch?.name || loginData?.strBranchName,
        selDestCity: selDestCity?.name,
        selBranch: selBranch?.name,
        selVehicle: selVehicle?.name,
        selPaymentTpe: selPaymentTpe?.name || 'All',
        reportType: reportType?.Name,
        showSummaryReport: showSummaryReport?.Name,
        detailedFilter: detailedFilter?.Name,
      },
    ]
    let doc = null
    if (detailedFilter?.Name === 'Vehicle wise Dispatch') {
      doc = new jsPDF({ orientation: 'l', format: [1680, 1187], unit: 'px', compress: true })
    } else if (showSummaryReport?.id === 1 && detailedFilter?.id === 1) {
      doc = new jsPDF({ orientation: 'l', format: [1800, 1272], unit: 'px', compress: true })
    } else if (showSummaryReport?.id === 0 && detailedFilter?.id === 0) {
      doc = new jsPDF({ orientation: 'p', format: [1754, 1240], unit: 'px', compress: true })
    } else if (detailedFilter?.Name === 'With Payment Type Group') {
      doc = new jsPDF({ orientation: 'l', format: [1580, 1116], unit: 'px', compress: true })
    } else if (detailedFilter?.Name === 'Show Only ToPay Amount') {
      doc = new jsPDF({ orientation: 'p', format: [1754, 1240], unit: 'px', compress: true })
    } else if (detailedFilter?.Name === 'With Hamali and Cartage') {
      doc = new jsPDF({ orientation: 'p', format: [1754, 1240], unit: 'px', compress: true })
    } else if (detailedFilter?.Name === 'With Other Charges') {
      doc = new jsPDF({ orientation: 'l', format: [1680, 1187], unit: 'px', compress: true })
    } else if (detailedFilter?.Name === 'Other Charges') {
      doc = new jsPDF({ orientation: 'l', format: [1680, 1187], unit: 'px', compress: true })
    } else if (detailedFilter?.Name === 'Branch Summary') {
      doc = new jsPDF({ orientation: 'p', format: [2022, 1429], unit: 'px', compress: true })
    }

    doc.autoTableSetDefaults({
      headStyles: { fontSize: 14, width: 'auto', halign: 'right', fillColor: [30, 89, 167] },
    })
    var totalPagesExp = '{total_pages_count_string}'
    const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
      const doc = data.doc
      // Footer
      var pageSize = doc.internal.pageSize
      var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
      var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

      var str = 'Page : ' + doc.internal.getNumberOfPages()
      if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
      }
      doc.setFontSize(16)
      doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 25, "right")
      doc.setFont('Roboto', 'bold')
      doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 25)
      doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 25)
    }
    let drawCell = function (data) {
      if (data.row.section === 'head') {
        if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
          data.cell.styles.halign = 'right'
        } else {
          data.cell.styles.halign = 'left'
        }
      }
      var rows = data.table.body
      if (detailedFilter?.Name === 'Vehicle wise Dispatch') {
        rows.map((val) => {
          if (val.raw.isSubHeading) {
            val.cells[0].text = val.raw.SN + " " + val.raw.DispatchDateTime + " " + val.raw.DispatchedToBranchFilter
            val.cells[0].colSpan = detailedColumns?.length
            val.cells[0].styles.font = 'Roboto'
            val.cells[0].styles.fontStyle = 'bold'
            val.cells[0].styles.fontSize = '16'
            val.cells[0].styles.halign = 'left'
            val.cells[0].styles.valign = 'middle'
            val.cells[0].styles.minCellHeight = 36
            val.cells[0].styles.fillColor = [245, 250, 254]
          }
        })
      } else {
        rows.map((val) => {
          if (Object.keys(val.raw).length === 3) {
            val.cells[0].colSpan = 2
            val.cells[0].styles.font = 'Roboto'
            val.cells[0].styles.fontStyle = 'bold'
            val.cells[0].styles.fontSize = '16'
            val.cells[0].styles.halign = 'right'
            val.cells[0].styles.fillColor = [245, 250, 254]
            val.cells[2].colSpan = 2
            val.cells[2].styles.font = 'Roboto'
            val.cells[2].styles.fontStyle = 'bold'
            val.cells[2].styles.fontSize = '16'
            val.cells[2].styles.halign = 'right'
            val.cells[2].styles.fillColor = [245, 250, 254]
            val.cells[4].colSpan = 2
            val.cells[4].styles.font = 'Roboto'
            val.cells[4].styles.fontStyle = 'bold'
            val.cells[4].styles.fontSize = '16'
            val.cells[4].styles.halign = 'right'
            val.cells[4].styles.fillColor = [245, 250, 254]
          }
          if (Object.keys(val.raw).length === 12) {
            if (val.raw.DispatchDateTime == '') {
              val.cells[0].colSpan = 18
              val.cells[0].styles.font = 'Roboto'
              val.cells[0].styles.fontStyle = 'bold'
              val.cells[0].styles.fontSize = '16'
              val.cells[0].styles.halign = 'left'
              val.cells[0].styles.valign = 'middle'
              val.cells[0].styles.minCellHeight = 36
              val.cells[0].styles.fillColor = [245, 250, 254]
            } else {
              val.cells[0].colSpan = 3
              val.cells[0].styles.font = 'Roboto'
              val.cells[0].styles.fontStyle = 'bold'
              val.cells[0].styles.fontSize = '16'
              val.cells[0].styles.halign = 'left'
              val.cells[0].styles.valign = 'middle'
              val.cells[0].styles.minCellHeight = 36
              val.cells[0].styles.fillColor = [245, 250, 254]
              val.cells[3].colSpan = 19
              val.cells[3].text = val.raw.DispatchDateTime.toString()
              val.cells[3].styles.font = 'Roboto'
              val.cells[3].styles.fontStyle = 'bold'
              val.cells[3].styles.fontSize = '16'
              val.cells[3].styles.halign = 'left'
              val.cells[3].styles.valign = 'middle'
              val.cells[3].styles.minCellHeight = 36
              val.cells[3].styles.fillColor = [245, 250, 254]
            }
          }
          if (Object.keys(val.raw).length == 13) {
            val.cells[0].colSpan = 12
            val.cells[0].styles.font = 'Roboto'
            val.cells[0].styles.fontStyle = 'bold'
            val.cells[0].styles.fontSize = '16'
            val.cells[0].styles.halign = 'right'
            val.cells[0].styles.fillColor = [208, 220, 238]
            for (let i = 12; i <= 22; i++) {
              val.cells[i].colSpan = 1
              val.cells[i].styles.font = 'Roboto'
              val.cells[i].styles.fontStyle = 'bold'
              val.cells[i].styles.fontSize = '16'
              val.cells[i].styles.halign = 'right'
              val.cells[i].styles.fillColor = [208, 220, 238]
            }
          }
          if (Object.keys(val.raw).length == 8) {
            val.cells[0].colSpan = 10
            val.cells[0].styles.font = 'Roboto'
            val.cells[0].styles.fontStyle = 'bold'
            val.cells[0].styles.fontSize = '16'
            val.cells[0].styles.halign = 'right'
            val.cells[0].styles.fillColor = [208, 220, 238]
            for (let i = 10; i <= 16; i++) {
              val.cells[i].colSpan = 1
              val.cells[i].styles.font = 'Roboto'
              val.cells[i].styles.fontStyle = 'bold'
              val.cells[i].styles.fontSize = '16'
              val.cells[i].styles.halign = 'right'
              val.cells[i].styles.fillColor = [208, 220, 238]
            }
          }
          if (Object.keys(val.raw).length == 4) {
            val.cells[0].colSpan = 5
            val.cells[0].styles.font = 'Roboto'
            val.cells[0].styles.fontStyle = 'bold'
            val.cells[0].styles.fontSize = '16'
            val.cells[0].styles.halign = 'right'
            val.cells[0].styles.fillColor = [238, 238, 238]
            val.cells[5].colSpan = 1
            val.cells[5].styles.font = 'Roboto'
            val.cells[5].styles.fontStyle = 'bold'
            val.cells[5].styles.fontSize = '16'
            val.cells[5].styles.halign = 'right'
            val.cells[5].styles.fillColor = [238, 238, 238]
            val.cells[6].colSpan = 2
            val.cells[6].styles.font = 'Roboto'
            val.cells[6].styles.fontStyle = 'bold'
            val.cells[6].styles.fontSize = '16'
            val.cells[6].styles.halign = 'right'
            val.cells[6].styles.fillColor = [238, 238, 238]
            val.cells[8].colSpan = 1
            val.cells[8].styles.font = 'Roboto'
            val.cells[8].styles.fontStyle = 'bold'
            val.cells[8].styles.fontSize = '16'
            val.cells[8].styles.halign = 'right'
            val.cells[8].styles.fillColor = [238, 238, 238]
            val.cells[9].colSpan = 1
            val.cells[9].styles.font = 'Roboto'
            val.cells[9].styles.fontStyle = 'bold'
            val.cells[9].styles.fontSize = '16'
            val.cells[9].styles.halign = 'right'
            val.cells[9].styles.fillColor = [238, 238, 238]
          }
          if (Object.keys(val.raw).length == 1) {
            val.cells[0].colSpan = 10
            val.cells[0].styles.font = 'Roboto'
            val.cells[0].styles.fontStyle = 'bold'
            val.cells[0].styles.fontSize = '16'
            val.cells[0].styles.halign = 'left'
            val.cells[0].styles.fillColor = [229, 243, 255]
          }
          if (Object.keys(val.raw).length == 22) {
            val.cells[0].colSpan = 1
            val.cells[0].styles.font = 'Roboto'
            val.cells[0].styles.fontStyle = 'bold'
            val.cells[0].styles.fontSize = '16'
            val.cells[0].styles.halign = 'right'
            val.cells[0].styles.valign = 'middle'
            val.cells[0].styles.minCellHeight = 36
            val.cells[0].styles.textColor = [0, 0, 0]
            val.cells[0].styles.fillColor = [238, 238, 238]
            val.cells[1].colSpan = 10
            val.cells[1].styles.font = 'Roboto'
            val.cells[1].styles.fontStyle = 'bold'
            val.cells[1].styles.fontSize = '16'
            val.cells[1].styles.halign = 'right'
            val.cells[1].styles.valign = 'middle'
            val.cells[1].styles.minCellHeight = 36
            val.cells[1].styles.textColor = [0, 0, 0]
            val.cells[1].styles.fillColor = [238, 238, 238]
            for (let i = 10; i <= 21; i++) {
              val.cells[i].colSpan = 1
              val.cells[i].styles.font = 'Roboto'
              val.cells[i].styles.fontStyle = 'bold'
              val.cells[i].styles.fontSize = '16'
              val.cells[i].styles.halign = 'right'
              val.cells[i].styles.valign = 'middle'
              val.cells[i].styles.minCellHeight = 36
              val.cells[i].styles.textColor = [0, 0, 0]
              val.cells[i].styles.fillColor = [238, 238, 238]
            }
          }
          if (Object.keys(val.raw).length == 15) {
            val.cells[0].colSpan = 3
            val.cells[0].styles.font = 'Roboto'
            val.cells[0].styles.fontStyle = 'bold'
            val.cells[0].styles.fontSize = '16'
            val.cells[0].styles.halign = 'right'
            val.cells[0].styles.valign = 'middle'
            val.cells[0].styles.minCellHeight = 36
            val.cells[0].styles.textColor = [0, 0, 0]
            val.cells[0].styles.fillColor = [238, 238, 238]
            val.cells[3].colSpan = 1
            val.cells[3].styles.font = 'Roboto'
            val.cells[3].styles.fontStyle = 'bold'
            val.cells[3].styles.fontSize = '16'
            val.cells[3].styles.halign = 'right'
            val.cells[3].styles.valign = 'middle'
            val.cells[3].styles.minCellHeight = 36
            val.cells[3].styles.textColor = [0, 0, 0]
            val.cells[3].styles.fillColor = [238, 238, 238]
            for (let i = 4; i <= 16; i++) {
              val.cells[i].colSpan = 1
              val.cells[i].styles.font = 'Roboto'
              val.cells[i].styles.fontStyle = 'bold'
              val.cells[i].styles.fontSize = '16'
              val.cells[i].styles.halign = 'right'
              val.cells[i].styles.valign = 'middle'
              val.cells[i].styles.minCellHeight = 36
              val.cells[i].styles.textColor = [0, 0, 0]
              val.cells[i].styles.fillColor = [238, 238, 238]
            }
          }
          if (Object.keys(val.raw).length == 23) {
            val.cells[0].colSpan = 2
            val.cells[0].styles.font = 'Roboto'
            val.cells[0].styles.fontStyle = 'bold'
            val.cells[0].styles.fontSize = '16'
            val.cells[0].styles.halign = 'right'
            val.cells[0].styles.valign = 'middle'
            val.cells[0].styles.minCellHeight = 36
            val.cells[0].styles.textColor = [0, 0, 0]
            val.cells[0].styles.fillColor = [238, 238, 238]
            val.cells[2].colSpan = 1
            val.cells[2].styles.font = 'Roboto'
            val.cells[2].styles.fontStyle = 'bold'
            val.cells[2].styles.fontSize = '16'
            val.cells[2].styles.halign = 'right'
            val.cells[2].styles.valign = 'middle'
            val.cells[2].styles.minCellHeight = 36
            val.cells[2].styles.textColor = [0, 0, 0]
            val.cells[2].styles.fillColor = [238, 238, 238]
            for (let i = 3; i <= 24; i++) {
              val.cells[i].colSpan = 1
              val.cells[i].styles.font = 'Roboto'
              val.cells[i].styles.fontStyle = 'bold'
              val.cells[i].styles.fontSize = '16'
              val.cells[i].styles.halign = 'right'
              val.cells[i].styles.valign = 'middle'
              val.cells[i].styles.minCellHeight = 36
              val.cells[i].styles.textColor = [0, 0, 0]
              val.cells[i].styles.fillColor = [238, 238, 238]
            }
          }
          if (Object.keys(val.raw).length == 21) {
            val.cells[0].colSpan = 1
            val.cells[0].styles.font = 'Roboto'
            val.cells[0].styles.fontStyle = 'bold'
            val.cells[0].styles.fontSize = '16'
            val.cells[0].styles.halign = 'right'
            val.cells[0].styles.valign = 'middle'
            val.cells[0].styles.minCellHeight = 36
            val.cells[0].styles.textColor = [0, 0, 0]
            val.cells[0].styles.fillColor = [238, 238, 238]
            val.cells[1].colSpan = 1
            val.cells[1].styles.font = 'Roboto'
            val.cells[1].styles.fontStyle = 'bold'
            val.cells[1].styles.fontSize = '16'
            val.cells[1].styles.halign = 'right'
            val.cells[1].styles.valign = 'middle'
            val.cells[1].styles.minCellHeight = 36
            val.cells[1].styles.textColor = [0, 0, 0]
            val.cells[1].styles.fillColor = [238, 238, 238]
            for (let i = 2; i <= 24; i++) {
              val.cells[i].colSpan = 1
              val.cells[i].styles.font = 'Roboto'
              val.cells[i].styles.fontStyle = 'bold'
              val.cells[i].styles.fontSize = '16'
              val.cells[i].styles.halign = 'right'
              val.cells[i].styles.valign = 'middle'
              val.cells[i].styles.minCellHeight = 36
              val.cells[i].styles.textColor = [0, 0, 0]
              val.cells[i].styles.fillColor = [238, 238, 238]
            }
          }
          if (Object.keys(val.raw).length == 17) {
            val.cells[0].colSpan = 1
            val.cells[0].styles.font = 'Roboto'
            val.cells[0].styles.fontStyle = 'bold'
            val.cells[0].styles.fontSize = '16'
            val.cells[0].styles.halign = 'right'
            val.cells[0].styles.valign = 'middle'
            val.cells[0].styles.minCellHeight = 36
            val.cells[0].styles.textColor = [0, 0, 0]
            val.cells[0].styles.fillColor = [238, 238, 238]
            val.cells[1].colSpan = 10
            val.cells[1].styles.font = 'Roboto'
            val.cells[1].styles.fontStyle = 'bold'
            val.cells[1].styles.fontSize = '16'
            val.cells[1].styles.halign = 'right'
            val.cells[1].styles.valign = 'middle'
            val.cells[1].styles.minCellHeight = 36
            val.cells[1].styles.textColor = [0, 0, 0]
            val.cells[1].styles.fillColor = [238, 238, 238]
            for (let i = 2; i <= 17; i++) {
              val.cells[i].colSpan = 1
              val.cells[i].styles.font = 'Roboto'
              val.cells[i].styles.fontStyle = 'bold'
              val.cells[i].styles.fontSize = '16'
              val.cells[i].styles.halign = 'right'
              val.cells[i].styles.valign = 'middle'
              val.cells[i].styles.minCellHeight = 36
              val.cells[i].styles.textColor = [0, 0, 0]
              val.cells[i].styles.fillColor = [238, 238, 238]
            }
          }
        })
      }
    }
    doc.setProperties({
      title: `Dispatch Report`,
      subject: 'Report',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })
    let paymentTypeGrouping = [];
    tableData.forEach((val) => {
      if (Object.keys(val).length !== 12 && Object.keys(val).length !== 17) {
        paymentTypeGrouping.push({
          ...val,
          OnlyLRNo: `${val.OnlyLRNo}\n${val.VoucherNo}\n${val.ManualLR}`,
          senderDetailes: `${val.SenderName}\n${val.SenderMobileNo}\n${val.SenderGSTN}\n${val.SenderEmailID}`,
          receiverDetailes: `${val.RecName}\n${val.RecMobileNo}\n${val.ReceiverGSTN}\n${val.ReceiverEmailID}`
        })
      } else {
        paymentTypeGrouping.push(val)
      }
    })
    autoTable(doc, {
      margin: { top: 180, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: HeaderData,
      columnStyles: {
        0: { fontSize: 18, valign: 'middle', font: 'Roboto', minCellHeight: 24, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0] },
        1: { fontSize: 18, valign: 'middle', font: 'Roboto', minCellHeight: 24, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0] },
        2: { fontSize: 18, valign: 'middle', font: 'Roboto', minCellHeight: 24, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0] },
        3: { fontSize: 18, valign: 'middle', font: 'Roboto', minCellHeight: 24, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0] },
        4: { fontSize: 18, valign: 'middle', font: 'Roboto', minCellHeight: 24, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0] },
        5: { fontSize: 18, valign: 'middle', font: 'Roboto', minCellHeight: 24, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0] },
        6: { fontSize: 18, valign: 'middle', font: 'Roboto', minCellHeight: 24, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0] },
        7: { fontSize: 18, valign: 'middle', font: 'Roboto', minCellHeight: 24, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0] },
      },
      theme: 'grid',
      showHead: 'firstPage',
      headStyles: {
        halign: 'left',
        valign: 'middle',
        cellPadding: 12,
        fontSize: 18,
        minCellHeight: 36,
        fillColor: [182, 222, 254],
        textColor: [0, 0, 0],
        fontStyle: 'bold',
        font: 'Roboto',
        lineWidth: 0.6,
      },
    })

    let colDataType =0
    if(detailedFilter.Name!=='Branch Summary'){
      colDataType = detailedColumns.filter((val) => val.xlCol.dataType === "string")
    }
    
    autoTable(doc, {
      margin: { top: 180, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },//withVehicleAndChartDateSummaryCol
      columns:
        showSummaryReport?.id === 1 && detailedFilter?.id === 1
          ? vihicleAndChartDatesummaryCol
          : detailedFilter?.Name === 'With Hamali and Cartage' || detailedFilter?.Name === 'Branch Summary'
            ? withHamaliAndCartageSummaryCol
            : detailedFilter?.Name === 'Vehicle wise Dispatch'
              ? detailedColumns
              : detailedFilter?.Name === 'With Payment Type Group'
                ? paymentDetailsCol
                : detailedFilter?.Name === 'Show Only ToPay Amount'
                  ? showOnlyToPayAmountCol
                  : detailedFilter?.Name === 'With Other Charges'
                    ? withOtherSummaryCol
                    : showSummaryReport?.id === 0 && detailedFilter?.id === 0 ?
                      withVehicleAndChartDateSummaryCol :detailedFilter?.Name === 'Other Charges'?withOtherChargesCol: '',
      body:
        detailedFilter?.Name === 'Show Only ToPay Amount'
          ? paymentSummary
          : showSummaryReport?.id === 1 && detailedFilter?.id === 1
            ? groupDataSecond
            : detailedFilter?.Name === 'With Payment Type Group' ? paymentTypeGrouping : tableData,
      columnStyles:
        detailedFilter?.Name === 'Vehicle wise Dispatch'
          ? {
            0: { halign: colDataType.length > 0 ? "left" : 'right', fontSize: 18, minCellWidth: 37, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
            1: { halign: colDataType.length > 1 ? "left" : 'right', fontSize: 18, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
            2: { halign: colDataType.length > 2 ? "left" : 'right', fontSize: 18, minCellWidth: 60, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
            3: { halign: colDataType.length > 3 ? "left" : 'right', fontSize: 18, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
            4: { halign: colDataType.length > 4 ? "left" : 'right', fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
            5: { halign: colDataType.length > 5 ? "left" : 'right', fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
            6: { halign: colDataType.length > 6 ? "left" : 'right', fontSize: 18, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
            7: { halign: colDataType.length > 7 ? "left" : 'right', fontSize: 18, maxCellWidth: 120, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
            8: { halign: colDataType.length > 8 ? "left" : 'right', fontSize: 18, maxCellWidth: 120, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
            9: { halign: colDataType.length > 9 ? "left" : 'right', fontSize: 18, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
            10: { halign: colDataType.length > 10 ? "left" : 'right', fontSize: 18, minCellWidth: 80, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
            11: { halign: colDataType.length > 11 ? "left" : 'right', fontSize: 18, minCellWidth: 50, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
            12: { halign: colDataType.length > 12 ? "left" : 'right', fontSize: 18, minCellWidth: 70, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
            13: { halign: colDataType.length > 13 ? "left" : 'right', fontSize: 18, minCellWidth: 60, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
            14: { halign: colDataType.length > 14 ? "left" : 'right', fontSize: 18, minCellWidth: 60, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
            15: { halign: colDataType.length > 15 ? "left" : 'right', fontSize: 18, minCellWidth: 60, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
            16: { halign: colDataType.length > 16 ? "left" : 'right', fontSize: 18, minCellWidth: 60, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
            17: { halign: colDataType.length > 17 ? "left" : 'right', fontSize: 18, minCellWidth: 50, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
            18: { halign: colDataType.length > 18 ? "left" : 'right', fontSize: 18, minCellWidth: 50, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
            19: { halign: colDataType.length > 19 ? "left" : 'right', fontSize: 18, minCellWidth: 70, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
            20: { halign: colDataType.length > 20 ? "left" : 'right', fontSize: 18, minCellWidth: 50, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
            21: { halign: colDataType.length > 21 ? "left" : 'right', fontSize: 18, minCellWidth: 60, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
          }
          : showSummaryReport?.id === 1 && detailedFilter?.id === 1
            ? {
              0: { fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', halign: 'left', fontStyle: 'normal' },
              1: { fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', halign: 'left', fontStyle: 'normal' },
              2: { fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', halign: 'left', fontStyle: 'normal' },
              3: { fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', halign: 'right', fontStyle: 'normal' },
              4: { fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', halign: 'right', fontStyle: 'normal' },
              5: { fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', halign: 'right', fontStyle: 'normal' },
              6: { fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', halign: 'right', fontStyle: 'normal' },
              7: { fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', halign: 'right', fontStyle: 'normal' },
              8: { fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', halign: 'right', fontStyle: 'normal' },
              9: { fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', halign: 'right', fontStyle: 'normal' },
              10: { fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', halign: 'right', fontStyle: 'normal' },
              11: { fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', halign: 'right', fontStyle: 'normal' },
              12: { fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', halign: 'right', fontStyle: 'normal' },
              13: { fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', halign: 'right', fontStyle: 'normal' },
              14: { fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', halign: 'right', fontStyle: 'normal' },
              15: { fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', halign: 'right', fontStyle: 'normal' },
              16: { fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', halign: 'right', fontStyle: 'normal' },
              17: { fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', halign: 'right', fontStyle: 'normal' },
              18: { fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', halign: 'right', fontStyle: 'normal' },
              19: { fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', halign: 'right', fontStyle: 'normal' },
              20: { fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', halign: 'right', fontStyle: 'normal' },
              21: { fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', halign: 'right', fontStyle: 'normal' },
              22: { fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', halign: 'right', fontStyle: 'normal' },
              23: { fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', halign: 'left', fontStyle: 'normal' },
              24: { fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', halign: 'left', fontStyle: 'normal' },
            }
            : detailedFilter?.Name === 'With Payment Type Group'
              ? {
                0: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                1: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                2: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                3: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                4: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                5: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                6: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                7: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                8: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', cellWidth: 120 },
                9: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', cellWidth: 120 },
                10: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', cellWidth: 90 },
                11: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                12: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                13: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                14: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                15: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                16: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                17: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
              }
              : detailedFilter?.Name === 'Show Only ToPay Amount'
                ? {
                  0: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                  1: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                  2: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                  3: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                  4: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                  5: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                  6: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                  7: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                  8: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                  9: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', cellWidth: 120 },
                }
                : detailedFilter?.Name === 'With Hamali and Cartage'
                  ? {
                    0: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                    1: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                    2: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                    3: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                    4: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                    5: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                    6: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                    7: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                    8: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                    9: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                    10: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                    11: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                    12: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                    13: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                    14: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                    15: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                    16: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                    17: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal' },
                  }
                  : detailedFilter?.Name === 'Branch Summary'
                    ? {
                      0: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                      1: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                      2: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                      3: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                      4: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                      5: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                      6: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                      7: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                      8: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                      9: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                      10: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                      11: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                      12: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                      13: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                      14: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                      15: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                      16: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                      17: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                    }
                    : detailedFilter?.Name === 'With Other Charges'
                      ? {
                        0: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        1: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        2: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        3: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        4: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        5: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        6: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        7: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        8: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        9: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', minCellWidth: 40 },
                        10: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        11: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        12: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        13: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        14: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        15: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', minCellWidth: 40 },
                        16: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        17: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        18: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        19: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        20: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        21: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        22: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        23: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        24: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', minCellWidth: 60 },
                      }: detailedFilter?.Name === 'Other Charges'
                      ? {
                        0: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        1: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        2: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        3: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        4: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        5: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        6: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        7: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        8: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        9: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', minCellWidth: 40 },
                        10: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        11: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        12: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        13: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        14: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        15: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', minCellWidth: 40 },
                        16: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        17: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        18: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        19: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                      }: showSummaryReport?.id === 0 && detailedFilter?.id === 0 ?
                        {
                          0: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                          1: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellWidth: 150, valign: 'middle', fontStyle: 'normal', },
                          2: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellWidth: 80, valign: 'middle', fontStyle: 'normal', },
                          3: { halign: 'left', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellWidth: 100, valign: 'middle', fontStyle: 'normal', },
                          4: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                          5: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                          6: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                          7: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                          8: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                          9: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', minCellWidth: 40 },
                          10: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                          11: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                          12: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                          13: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                          14: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                          15: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', minCellWidth: 40 },
                          16: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                          17: { halign: 'right', fontSize: 18, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', fontStyle: 'normal', },
                        } : '',

      theme: 'grid',
      styles: {
        lineWidth: [0, 0.2, 0, 0.6],
      },
      tableLineWidth: 0.6,
      headStyles: {
        fontSize: 16,
        fillColor: [182, 222, 254],
        textColor: [0, 0, 0],
        cellPadding: 6,
        valign: 'middle',
        fontStyle: 'bold'
      },
      didParseCell: (data) => {
        drawCell(data)
        if (detailedFilter?.Name === 'Other Charges') {
          if (data.row.section === 'head') {
            if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
              data.cell.styles.halign = 'right'
            } else {
              data.cell.styles.halign = 'left'
            }
          }
        }
      },
      willDrawCell: (data) => {
        if (data?.row?.raw?.PaymentType?.trim() === "Total") {
          data.cell.styles.halign = 'right';
          doc.setFillColor(238, 238, 238);
          doc.setTextColor(0, 0, 0);
          doc.setFontSize(16).setFont("Roboto", 'bold')
        }
      },
      didDrawPage: function (data) {
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(18)
        doc.setFont("Roboto", 'bold')
        doc.text(`From Dispatch : ${moment(fromDate).format('DD-MMM-YYYY')} To ${moment(toDate).format('DD-MMM-YYYY')}`, 30, 170)
        doc.setFontSize(18)
        doc.setFont("Roboto", 'bold')
        doc.text(`${showSummaryReport?.Name}-${detailedFilter?.Name}`, doc.internal.pageSize.width - data.settings.margin.left, 170, 'right')
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont("Roboto", 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System | Dispatch Reports', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont("Roboto", 'bold')
        doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, "right")
        jsPdfHeaderFooter(data, loginData, totalPagesExp)
      },
    })
    if (detailedFilter?.Name === 'Vehicle wise Dispatch') {
      autoTable(doc, {
        margin: { top: 90, left: 30, right: 30, bottom: 40 },
        alternateRowStyles: {
          fillColor: [255, 255, 255],
        },
        columns: summaryColumns,
        body: paymentWiseTotal,
        columnStyles: {
          0: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], halign: 'left' },
          1: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], halign: 'right' },
          2: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], halign: 'right' },
          3: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], halign: 'right' },
          4: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], halign: 'right' },
          5: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], halign: 'right' },
          6: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], halign: 'right' },
          7: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], halign: 'right' },
          8: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], halign: 'right' },
          9: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], halign: 'right' },
          10: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], halign: 'right' },
          11: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], halign: 'right' },
          12: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], halign: 'right' },
        },
        theme: 'grid',
        styles: {
          lineWidth: [0, 0.2, 0, 0.2],
        },
        tableLineWidth: 0.2,
        headStyles: {
          fontSize: 16,
          fillColor: [182, 222, 254],
          textColor: [0, 0, 0],
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'bold'
        },
        didParseCell: (data) => {
          if (data.row.section === 'head') {
            if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
              data.cell.styles.halign = 'right'
            } else {
              data.cell.styles.halign = 'left'
            }
          }
        },
      })
    } else if (detailedFilter?.Name === 'Show Only ToPay Amount') {
      autoTable(doc, {
        margin: { top: 90, left: 30, right: 30, bottom: 40 },
        alternateRowStyles: {
          fillColor: [255, 255, 255],
        },
        columns: showOnlyToPayAmountSummaryCol,
        body: paymentWiseVehicleData,
        columnStyles: {
          0: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'left' },
          1: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right' },
          2: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right' },
          3: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right' },
          4: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right', minCellWidth: 40 },
          5: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right' },
          6: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right' },
          7: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right' },
          8: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right' },
          9: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right' },
          10: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right' },
          11: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right' },
          12: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right' },
          13: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right' },
          14: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right' },
          15: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right' },
          16: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right' },
          17: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right' },
          18: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right' },
          19: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right' },
          20: { fontSize: 16, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, valign: 'middle', cellPadding: 6, halign: 'right', minCellWidth: 60 },
        },
        theme: 'grid',
        didParseCell: (data) => {
          if (data.row.section === 'head') {
            if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
              data.cell.styles.halign = 'right'
            } else {
              data.cell.styles.halign = 'left'
            }
          }
        },
        styles: {
          lineWidth: [0, 0.2, 0, 0.2],
        },
        tableLineWidth: 0.2,
        headStyles: {
          fontSize: 16,
          fillColor: [182, 222, 254],
          textColor: [0, 0, 0],
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'bold'
        },
      })
    }
    doc.setFont('Roboto')
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`Dispatch Report ${currentDateTime}.pdf`)
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('Reportoutput').data = pdfUrl
        // document.getElementById('Reportoutput').data = doc.output('datauristring', ' Dispatch Report')
        focusElemnt('DispatchBackBtn')
      }, 2000)
    } else {
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('Reportoutput').data = pdfUrl
        // document.getElementById('Reportoutput').data = doc.output('datauristring', ' Dispatch Report')
        focusElemnt('DispatchBackBtn')
      }, 2000)
    }
  }
  const generatepdf2 = (isSave) => {
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(["addFonts", callAddFontRobotoBold]);
    jsPDF.API.events.push(["addFonts", callAddFontRobotoMedium]);
    const vehicleWIthDispatchSummaryColumn=getVehicleWithDispatchSummaryColumn(UseToPayAsCOD)
    const widthCell = calculateTotalTableWidth(vehicleWIthDispatchSummaryColumn)
    const HeaderColumn = [
      {
        headerName: 'Company',
        exportHead: 'Company',
        field: 'company',
        xlCol: { dataType: 'string', dataFormatter: null },
      },

      {
        headerName: 'From Dispatch Date',
        exportHead: 'From Dispatch Date',
        field: 'fromDate',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'To Dispatch Date',
        exportHead: 'To Dispatch Date',
        field: 'toDate',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Dispatch By Branch',
        exportHead: 'Dispatch By Branch',
        field: 'selFromBranch',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Destination City',
        exportHead: 'Destination City',
        field: 'selDestCity',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Destination Branch',
        exportHead: 'Destination Branch',
        field: 'selBranch',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      // {
      //   headerName: 'Report View',
      //   exportHead: 'Report View',
      //   field: 'showSummaryReport',
      //   xlCol: { dataType: 'string', dataFormatter: null },
      // },
      // {
      //   headerName: 'Report Option',
      //   exportHead: 'Report Option',
      //   field: 'detailedFilter',
      //   xlCol: { dataType: 'string', dataFormatter: null },
      // },
    ]
    const HeaderColumn1 = [
      {
        headerName: 'Vehicle No',
        exportHead: 'Vehicle No',
        field: 'selVehicle',
        xlCol: { dataType: 'string', dataFormatter: null },
      },

      {
        headerName: 'Payment Type',
        exportHead: 'Payment Type',
        field: 'selPaymentTpe',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Report Type',
        exportHead: 'Report Type',
        field: 'reportType',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Report View',
        exportHead: 'Report View',
        field: 'reportView',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Report Option',
        exportHead: 'Report Option',
        field: 'reportOpt',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
        ]
    const HeaderColumns = HeaderColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const HeaderColumns1 = HeaderColumn1.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })

    const pdfColumns = vehicleWIthDispatchSummaryColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol };
    })

    const pdfColumnsTwo = headerColumnChallanWiseDispatchSummaryColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol };
    })


    const HeaderData = [
      {
        company: loginData.strCompanyName,
        fromDate: moment(fromDate).format('DD-MMM-YYYY'),
        toDate: moment(toDate).format('DD-MMM-YYYY'),
        selFromBranch: selFromBranch?.name || loginData?.strBranchName,
        selBranch: selBranch?.name,
        selDestCity: selDestCity?.name
        // selFromBranch: selFromBranch?.name || loginData?.strBranchName,
        // selDestCity: selDestCity?.name,
        // selBranch: selBranch?.name,
        // selVehicle: selVehicle?.name,
        // selPaymentTpe: selPaymentTpe?.name || 'All',
        // reportType: reportType?.Name,
        // showSummaryReport: showSummaryReport?.Name,
        // detailedFilter: detailedFilter?.Name,
      },
    ]
    const HeaderData1 = [
      {
        selVehicle: selVehicle?.name,
        selPaymentTpe: selPaymentTpe?.name || 'All',
        reportType: reportType?.Name,
        reportView: 'Summary',
        reportOpt: 'Vehicle Wise Dispatch',
        // selFromBranch: selFromBranch?.name || loginData?.strBranchName,
        // selDestCity: selDestCity?.name,
        // selBranch: selBranch?.name,
        // selVehicle: selVehicle?.name,
        // selPaymentTpe: selPaymentTpe?.name || 'All',
        // reportType: reportType?.Name,
        // showSummaryReport: showSummaryReport?.Name,
        // detailedFilter: detailedFilter?.Name,
      },
    ]
    const doc = new jsPDF({ orientation: pdfColumns.length > 12 ? 'l' : 'p', format: pdfColumns.length > 12 ? calculateDynamicFormatLandscape((widthCell > 1400 ? widthCell : 1400) + 60) : calculateDynamicFormatPortrait((widthCell > 793 ? widthCell : 793) + 60), unit: 'px', compress: true })
    var pageSize = doc.internal.pageSize
    // var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
    var scaleFactor = pageWidth / (pdfColumns.length > 12 ? 1122 : 793);

    var totalPagesExp = '{total_pages_count_string}'
    const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
      const doc = data.doc
      // Footer
      var pageSize = doc.internal.pageSize
      var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
      var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

      var str = 'Page : ' + doc.internal.getNumberOfPages()
      if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
      }
      doc.setFontSize(scaleFactor * 14)
      doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, "right")
      doc.setFont('Roboto', 'bold')
      doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
      doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 5)
    }
    // let drawCell = function (data) {
    //   var rows = data.table.body
    //   rows.map((val) => {
    //     console.log(val)
    //     if (val.raw.isTotal) {
    //       val.cells[0].colSpan = 5
    //       val.cells[0].text = val?.raw?.LrManNo
    //       val.cells[0].styles.font = 'Roboto'
    //       val.cells[0].styles.fontStyle = 'normal'
    //       val.cells[0].styles.fontSize = scaleFactor * 12
    //       val.cells[0].styles.halign = 'right'
    //       val.cells[0].styles.valign = 'middle'
    //       val.cells[0].styles.fillColor = [238, 238, 238]
    //       val.cells[0].styles.textColor = [0, 0, 0]
    //       val.cells[0].styles.cellPadding = 6
    //     }
    //   })
    // }
    doc.setProperties({
      title: `Vehicle Wise Dispatch.pdf`,
      subject: 'Vehicle Wise Dispatch',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })

    autoTable(doc, {
      margin: { top: 60, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: HeaderData,
      columnStyles: {
        0: { fontSize: scaleFactor * 14, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        1: { fontSize: scaleFactor * 14, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        2: { fontSize: scaleFactor * 14, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        3: { fontSize: scaleFactor * 14, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        4: { fontSize: scaleFactor * 14, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        5: { fontSize: scaleFactor * 14, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
      },
      theme: 'grid',
      startY: 160,
      headStyles: {
        fillColor: [191, 225, 255],
        textColor: [0, 0, 0],
        minCellHeight: 36,
        valign: 'middle',
        cellPadding: 12,
        fontSize: scaleFactor * 14,
        font: 'Roboto',
        fontStyle: 'normal',
        lineWidth: 0.6,
      },
    })
    autoTable(doc, {
      
      margin: { top: 120, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns1,
      body: HeaderData1,
      columnStyles: {
        0: { fontSize: scaleFactor * 14, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        1: { fontSize: scaleFactor * 14, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        2: { fontSize: scaleFactor * 14, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        3: { fontSize: scaleFactor * 14, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        4: { fontSize: scaleFactor * 14, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        5: { fontSize: scaleFactor * 14, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
      },
      theme: 'grid',
      
      startY: doc.lastAutoTable.finalY + 10,
      headStyles: {
        fillColor: [191, 225, 255],
        textColor: [0, 0, 0],
        minCellHeight: 36,
        valign: 'middle',
        cellPadding: 12,
        fontSize: scaleFactor * 14,
        font: 'Roboto',
        fontStyle: 'normal',
        lineWidth: 0.6,
      },
    })
    autoTable(doc, {
      margin: { top: 180, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fillColor: [191, 225, 255],
        fontSize: scaleFactor * 12,
        minCellHeight: 36,
        cellPadding: 6,
        valign: 'middle',
        fontStyle: 'normal',
        font: 'Roboto',
        textColor: [0, 0, 0]
      },
      tableLineWidth: 0.6,
      columns:tableindex===8? pdfColumns:pdfColumnsTwo,
      body: tableData,
      styles: {
        lineWidth: [0, 0.2, 0, 0.2]
      },
      columnStyles:tableindex===8? {
        0: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'left', textColor: [0, 0, 0] },
        1: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 70, halign: 'left', textColor: [0, 0, 0] },
        2: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'left', textColor: [0, 0, 0] },
        3: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'left', textColor: [0, 0, 0] },
        4: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'left', textColor: [0, 0, 0] },
        5: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'left', textColor: [0, 0, 0] },
        6: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'right', textColor: [0, 0, 0] },
        7: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'right', textColor: [0, 0, 0] },
        8: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'right', textColor: [0, 0, 0] },
        9: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 30, halign: 'right', textColor: [0, 0, 0] },
        10: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 30, halign: 'right', textColor: [0, 0, 0] },
        11: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 30, halign: 'right', textColor: [0, 0, 0] },
        12: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 30, halign: 'right', textColor: [0, 0, 0] },
        13: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 30, halign: 'right', textColor: [0, 0, 0] },
        14: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 30, halign: 'right', textColor: [0, 0, 0] },
        15: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 30, halign: 'right', textColor: [0, 0, 0] },
      }: {
        0: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'left', textColor: [0, 0, 0] },
        1: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 70, halign: 'left', textColor: [0, 0, 0] },
        2: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'left', textColor: [0, 0, 0] },
        3: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'left', textColor: [0, 0, 0] },
        4: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'left', textColor: [0, 0, 0] },
        5: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'right', textColor: [0, 0, 0] },
        6: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'right', textColor: [0, 0, 0] },
        7: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'right', textColor: [0, 0, 0] },
      },
      theme: 'grid',
      // showHead: "never",
      didParseCell: (data) => {
        if (data.row.section === 'head') {
          if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
            data.cell.styles.halign = 'right'
          } else {
            data.cell.styles.halign = 'left'
          }
        }
        // drawCell(data)
      },
      willDrawCell: (data) => {
        if (data.row.raw.isHeading) {
          doc.setFillColor(191, 225, 255)
          // doc.setFillColor(241, 249, 255)
          doc.setTextColor(0, 0, 0)
          doc.setFontSize(scaleFactor * 12).setFont(undefined, 'bold')
        } else if (data.row.raw.isSubHeading) {
          doc.setFillColor(241, 249, 255)
          // doc.setFillColor(191, 225, 255)
          doc.setTextColor(0, 0, 0)
          doc.setFontSize(scaleFactor * 12).setFont(undefined, 'bold')
        } else if (data.row.raw.isTotalRow) {
          doc.setFillColor(238, 238, 238)
          doc.setTextColor(0, 0, 0)
          // doc.cell.styles.valign='middle'
          data.cell.styles.valign = 'middle';
          doc.setFontSize(scaleFactor * 12).setFont(undefined, 'bold')
        }
      },
      didDrawPage: function (data) {
        doc.setTextColor(scaleFactor * 40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(scaleFactor * 20).setFont("Roboto", 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System | Dispatch Report', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(scaleFactor * 20).setFont("Roboto", 'bold')
        doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, "right")
        jsPdfHeaderFooter(data, loginData, totalPagesExp)
      },
    })
    doc.setFont('Roboto')

    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`Dispatch Report ${new Date().getTime()}.pdf`)
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('Reportoutput').data = pdfUrl
        // document.getElementById('Reportoutput').data = doc.output('datauristring', 'DeliveryDetailedReport..pdf')
        focusElemnt('backBtn')
      }, 2000)
    } else {
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('Reportoutput').data = pdfUrl
        // document.getElementById('Reportoutput').data = doc.output('datauristring', 'DeliveryDetailedReport..pdf')
        focusElemnt('backBtn')
      }, 2000)
    }

  }
  const printClick = (isSave) => {
    if (tableindex === 8|| tableindex === 9) {
      setShowTable(false)
      generatepdf2(isSave)
    } else {
      setShowTable(false)
      generatepdf(isSave)
    }

  }
  const getTable = (typeInd, tableData, manageColumn) => {
    switch (typeInd) {
      case 0:
        return (
          <DispatchMiddSection1
            tableData={tableData}
            selFromBranch={selFromBranch}
            selDestCity={selDestCity}
            selBranch={selBranch}
            loginData={loginData}
            toDate={toDate}
            fromDate={fromDate}
            selVehicle={selVehicle}
            selPaymentTpe={selPaymentTpe}
            reportType={reportType}
            showSummaryReport={showSummaryReport}
            detailedFilter={detailedFilter}
            paymentWiseTotal={paymentWiseTotal}
            columns={manageColumn}
            selectedFields={selectedFields}
          />
        ) //Vehicle Wise Dispatch
      case 1:
        return (
          <DispatchMiddSection3
            tableData={tableData}
            selFromBranch={selFromBranch}
            selDestCity={selDestCity}
            selBranch={selBranch}
            loginData={loginData}
            toDate={toDate}
            fromDate={fromDate}
            selVehicle={selVehicle}
            selPaymentTpe={selPaymentTpe}
            reportType={reportType}
            showSummaryReport={showSummaryReport}
            detailedFilter={detailedFilter}
            groupDataSecond={groupDataSecond}
          />
        ) //With Vehicle and chart date
      case 2:
        return (
          <DispatchMiddSection2
            tableData={tableData}
            selFromBranch={selFromBranch}
            selDestCity={selDestCity}
            selBranch={selBranch}
            loginData={loginData}
            toDate={toDate}
            fromDate={fromDate}
            selVehicle={selVehicle}
            selPaymentTpe={selPaymentTpe}
            reportType={reportType}
            showSummaryReport={showSummaryReport}
            detailedFilter={detailedFilter}
          />
        ) //with payment type group
      case 3:
        return (
          <DispatchMiddSection4
            tableData={tableData}
            selFromBranch={selFromBranch}
            selDestCity={selDestCity}
            selBranch={selBranch}
            loginData={loginData}
            toDate={toDate}
            fromDate={fromDate}
            selVehicle={selVehicle}
            selPaymentTpe={selPaymentTpe}
            reportType={reportType}
            showSummaryReport={showSummaryReport}
            detailedFilter={detailedFilter}
            paymentSummary={paymentSummary}
            paymentWiseVehicleData={paymentWiseVehicleData}
          />
        ) //show only To Pay Amount
      case 4:
        return (
          <DispatchMiddSection5
            tableData={tableData}
            selFromBranch={selFromBranch}
            selDestCity={selDestCity}
            selBranch={selBranch}
            loginData={loginData}
            toDate={toDate}
            fromDate={fromDate}
            selVehicle={selVehicle}
            selPaymentTpe={selPaymentTpe}
            reportType={reportType}
            showSummaryReport={showSummaryReport}
            detailedFilter={detailedFilter}
          />
        )
      case 5:
        return (
          <DispatchMiddSection6
            tableData={tableData}
            selFromBranch={selFromBranch}
            selDestCity={selDestCity}
            selBranch={selBranch}
            loginData={loginData}
            toDate={toDate}
            fromDate={fromDate}
            selVehicle={selVehicle}
            selPaymentTpe={selPaymentTpe}
            reportType={reportType}
            showSummaryReport={showSummaryReport}
            detailedFilter={detailedFilter}
          />
        )
      case 6:
        return (
          <DispatchMiddSection7
            tableData={tableData}
            selFromBranch={selFromBranch}
            selDestCity={selDestCity}
            selBranch={selBranch}
            loginData={loginData}
            toDate={toDate}
            fromDate={fromDate}
            selVehicle={selVehicle}
            selPaymentTpe={selPaymentTpe}
            reportType={reportType}
            showSummaryReport={showSummaryReport}
            detailedFilter={detailedFilter}
          />
        )
      case 7:
        return (
          <DispatchMiddSection8
            tableData={tableData}
            selFromBranch={selFromBranch}
            selDestCity={selDestCity}
            selBranch={selBranch}
            loginData={loginData}
            toDate={toDate}
            fromDate={fromDate}
            selVehicle={selVehicle}
            selPaymentTpe={selPaymentTpe}
            reportType={reportType}
            showSummaryReport={showSummaryReport}
            detailedFilter={detailedFilter}
          />
        )
      case 8:
        return (
          <DispatchMiddSection9
            tableData={tableData}
            selFromBranch={selFromBranch}
            selDestCity={selDestCity}
            selBranch={selBranch}
            loginData={loginData}
            toDate={toDate}
            fromDate={fromDate}
            selVehicle={selVehicle}
            selPaymentTpe={selPaymentTpe}
            reportType={reportType}
            showSummaryReport={showSummaryReport}
            detailedFilter={detailedFilter}
          />
        )
      case 9:
        return (
          <DispatchMiddSection10
            tableData={tableData}
            selFromBranch={selFromBranch}
            selDestCity={selDestCity}
            selBranch={selBranch}
            loginData={loginData}
            toDate={toDate}
            fromDate={fromDate}
            selVehicle={selVehicle}
            selPaymentTpe={selPaymentTpe}
            reportType={reportType}
            showSummaryReport={showSummaryReport}
            detailedFilter={detailedFilter}
          />
        )
      case 10:
        return (
          <WithOtherCharges
            tableData={tableData}
            selFromBranch={selFromBranch}
            selDestCity={selDestCity}
            selBranch={selBranch}
            loginData={loginData}
            toDate={toDate}
            fromDate={fromDate}
            selVehicle={selVehicle}
            selPaymentTpe={selPaymentTpe}
            reportType={reportType}
            showSummaryReport={showSummaryReport}
            detailedFilter={detailedFilter}
          />
        )
      default:
        return <DispatchMiddSection1 tableData={tableData} />
    }
  }

  const [page, setPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(8)
  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }
  function TablePaginationActions(props) {
    const theme = useTheme()
    const { count, page, rowsPerPage, onPageChange } = props
    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0)
      setState({ ...state, startIndex: 0, lastIndex: 8 })
    }
    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1)
      setState({ ...state, startIndex: startIndex - 8, lastIndex: startIndex })
    }
    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1)
      if (tableData.length >= lastIndex + 8) {
        setState({ ...state, startIndex: lastIndex, lastIndex: lastIndex + 8 })
      } else {
        setState({ ...state, startIndex: lastIndex, lastIndex: tableData?.length + 1 })
      }
    }
    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
      const div = tableData?.length % 8
      if (div == 0) {
        const index = tableData?.length - 8
        setState({ ...state, startIndex: index, lastIndex: tableData?.length + 1 })
      } else {
        const index = tableData?.length - (tableData?.length % 8)
        setState({ ...state, startIndex: index, lastIndex: tableData?.length + 1 })
      }
    }
    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
          style={{ padding: '0px', margin: '0px' }}
        >
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          style={{ padding: '0px', margin: '0px' }}
          aria-label="previous page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          style={{ padding: '0px', margin: '0px' }}
          aria-label="next page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          style={{ padding: '0px', margin: '0px' }}
          aria-label="last page"
        >
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    )
  }
  TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
  }
  useEffect(() => {
    setTableData(dispatchDetailsTableData)
  }, [dispatchDetailsTableData])
  useEffect(() => {
     if(challanWiseDispatchTableData?.Data?.Table.length>0){
      let updatedData = challanWiseDispatchTableData?.Data?.Table?.map((item, index) => ({
              ...item,
              SN: index + 1,
              isDataRow: true
            }));
        
            const totalNOP = updatedData.reduce((sum, row) => sum + (row.Quantity || 0), 0);
            const totalTotal = updatedData.reduce((sum, row) => sum + (row.Total || 0), 0);
            const totalLess = updatedData.reduce((sum, row) => sum + (row.Less || 0), 0);
        
            // Add total row
            updatedData.push({
              isTotal: true,
              isTotalRow:true,
              SN: "Total",
              ToCity: "",
              FromTo: "",
              ItemDetails: "",
              DispatchDate: "",
              Quantity: totalNOP,
              Total: totalTotal,
              Less: totalLess
            });
            setTableData(updatedData)
}
}, [challanWiseDispatchTableData])

  useEffect(() => {
    setTableData(DispatchMemoDetailTableData)
  }, [DispatchMemoDetailTableData])
  useEffect(() => {
    if (detailedFilter?.Name === 'With Hamali and Cartage') {
      if (dispatchSummaryTableData?.Data?.Table?.length > 0) {
        const updatedData=dispatchSummaryTableData?.Data?.Table?.map((val, i) => ({
          ...val,
          SN: i + 1,
          HamaliTotal: val.DDDVHamali + val.FocAndSelfHamali + val.OnAccountHamali + val.PaidHamali + val.TopayHamali,
          CartageTotal: val.DDDVCartage + val.FocAndSelfCartage + val.OnAccountCartage + val.PaidCartage + val.TopayCartage,
          GstTotal: val.DDDVGST + val.FocAndSelfGST + val.OnAccountGST + val.PaidGST + val.TopayGST,
          ValuationTotal: val.DDDVInsurance + val.FocAndSelfInsurance + val.OnAccountInsurance + val.PaidInsurance + val.TopayInsurance,
          OtherChargeTotal: val.DDDVOther + val.FocAndSelfOther + val.OnAccountOther + val.PaidOther + val.TopayOther,
        }))
        const totalDataTable = updatedData.map((val)=>({...val,OtherChargeTotal:val.OtherChargeTotal-val.HamaliTotal-val.CartageTotal-val.GstTotal-val.ValuationTotal}))

        let unitTotal = 0
        let AllTotalLrs = 0
        let AllTotalFreight = 0
        let PaidFreigh = 0
        let AllTotalToPayCodFreightPaid = 0
        let AllTotalOnAcountFreight = 0
        let AllTotalFocSelfFreight = 0
        let AllTotalDddvFreight = 0
        let AllTotalHamali = 0
        let AllTotalCartage = 0
        let AllTotalGst = 0
        let AllTotalValuation = 0
        let AllTotalOtherCharges = 0
        let AllTotalNetAmount = 0
        totalDataTable?.map((val) => {
          unitTotal += Number(val.TotalUnits)
          AllTotalLrs += Number(val.TotalLRCount)
          AllTotalFreight += Number(val.TotalFreight)
          AllTotalToPayCodFreightPaid += Number(val.TopayFreight)
          PaidFreigh += Number(val.PaidFreight)
          AllTotalOnAcountFreight += Number(val.OnAccountFreight)
          AllTotalFocSelfFreight += Number(val.FocAndSelfFreight)
          AllTotalDddvFreight += Number(val.DDDVFreight)
          AllTotalHamali += Number(val.HamaliTotal)
          AllTotalCartage += Number(val.CartageTotal)
          AllTotalGst += Number(val.GstTotal)
          AllTotalValuation += Number(val.ValuationTotal)
          AllTotalOtherCharges += Number(val.OtherChargeTotal)
          AllTotalNetAmount += Number(val.TotalNetAmount)
        })
        totalDataTable.push({
          Station: 'TOTAL AMOUNT',
          TotalUnits: unitTotal,
          TotalLRCount: AllTotalLrs,
          TotalFreight: AllTotalFreight,
          TopayFreight: AllTotalToPayCodFreightPaid,
          PaidFreight: PaidFreigh,
          OnAccountFreight: AllTotalOnAcountFreight,
          FocAndSelfFreight: AllTotalFocSelfFreight,
          DDDVFreight: AllTotalDddvFreight,
          HamaliTotal: AllTotalHamali,
          CartageTotal: AllTotalCartage,
          GstTotal: AllTotalGst,
          ValuationTotal: AllTotalValuation,
          OtherChargeTotal: AllTotalOtherCharges,
          TotalNetAmount: AllTotalNetAmount,
        })
        setTableData(totalDataTable)
      } else {
        setTableData([])
      }
    } else if (detailedFilter?.Name === 'Branch Summary') {
      if (dispatchSummaryTableData?.Data?.Table1?.length > 0) {
        const updatedData=dispatchSummaryTableData?.Data?.Table1?.map((val, i) => ({
          ...val,
          SN: i + 1,
          HamaliTotal: val.DDDVHamali + val.FocAndSelfHamali + val.OnAccountHamali + val.PaidHamali + val.TopayHamali,
          CartageTotal: val.DDDVCartage + val.FocAndSelfCartage + val.OnAccountCartage + val.PaidCartage + val.TopayCartage,
          GstTotal: val.DDDVGST + val.FocAndSelfGST + val.OnAccountGST + val.PaidGST + val.TopayGST,
          ValuationTotal: val.DDDVInsurance + val.FocAndSelfInsurance + val.OnAccountInsurance + val.PaidInsurance + val.TopayInsurance,
          OtherChargeTotal: val.DDDVOther + val.FocAndSelfOther + val.OnAccountOther + val.PaidOther + val.TopayOther,
        }))
        const totalDataTableOne = updatedData.map((val)=>({...val,OtherChargeTotal:val.OtherChargeTotal-val.HamaliTotal-val.CartageTotal-val.GstTotal-val.ValuationTotal}))
        let unitTotal = 0
        let AllTotalLrs = 0
        let AllTotalFreight = 0
        let PaidFreigh = 0
        let AllTotalToPayCodFreightPaid = 0
        let AllTotalOnAcountFreight = 0
        let AllTotalFocSelfFreight = 0
        let AllTotalDddvFreight = 0
        let AllTotalHamali = 0
        let AllTotalCartage = 0
        let AllTotalGst = 0
        let AllTotalValuation = 0
        let AllTotalOtherCharges = 0
        let AllTotalNetAmount = 0
        totalDataTableOne?.map((val) => {
          unitTotal += Number(val.TotalUnits)
          AllTotalLrs += Number(val.TotalLRCount)
          AllTotalFreight += Number(val.TotalFreight)
          AllTotalToPayCodFreightPaid += Number(val.TopayFreight)
          PaidFreigh += Number(val.PaidFreight)
          AllTotalOnAcountFreight += Number(val.OnAccountFreight)
          AllTotalFocSelfFreight += Number(val.FocAndSelfFreight)
          AllTotalDddvFreight += Number(val.DDDVFreight)
          AllTotalHamali += Number(val.HamaliTotal)
          AllTotalCartage += Number(val.CartageTotal)
          AllTotalGst += Number(val.GstTotal)
          AllTotalValuation += Number(val.ValuationTotal)
          AllTotalOtherCharges += Number(val.OtherChargeTotal)
          AllTotalNetAmount += Number(val.TotalNetAmount)
        })
        totalDataTableOne.push({
          Station: 'TOTAL AMOUNT',
          TotalUnits: unitTotal,
          TotalLRCount: AllTotalLrs,
          TotalFreight: AllTotalFreight,
          TopayFreight: AllTotalToPayCodFreightPaid,
          PaidFreight: PaidFreigh,
          OnAccountFreight: AllTotalOnAcountFreight,
          FocAndSelfFreight: AllTotalFocSelfFreight,
          DDDVFreight: AllTotalDddvFreight,
          HamaliTotal: AllTotalHamali,
          CartageTotal: AllTotalCartage,
          GstTotal: AllTotalGst,
          ValuationTotal: AllTotalValuation,
          OtherChargeTotal: AllTotalOtherCharges,
          TotalNetAmount: AllTotalNetAmount,
        })
        setTableData(totalDataTableOne)
      } else {
        setTableData([])
      }
    } else if (detailedFilter?.Name === 'With Other Charges') {
      if (dispatchSummaryTableData?.Data?.Table1?.length > 0) {
        const totalDataTableOne = dispatchSummaryTableData?.Data?.Table1?.map((val) => ({
          ...val,
          TopayCodGstOth: val.TopayGST + val.TopayOther,
          PaidGstOth: val.PaidGST + val.PaidOther,
          OnActGstOth: val.OnAccountGST + val.OnAccountOther,
          FOCSelfGstOth: val.FocAndSelfGST + val.FocAndSelfOther,
          DDDVGstOth: val.DDDVGST + val.DDDVOther,
          OtherCharge: val.TopayOther + val.PaidOther + val.OnAccountOther + val.FocAndSelfOther + val.DDDVOther,
        }))
        const totalDatatwo = totalDataTableOne?.map((val) => ({
          ...val,
          NetOther: val.TopayCodGstOth + val.PaidGstOth + val.OnActGstOth + val.FOCSelfGstOth + val.DDDVGstOth-val.Insurance,
        }))
        let TopayCodunitTotal = 0
        let PaidunitTotal = 0
        let OnActunitTotal = 0
        let FocSelfunitTotal = 0
        let DDDVunitTotal = 0
        let NetunitTotal = 0
        let AllTotalToPayCodFreight = 0
        let AllPaidFreight = 0
        let AllTotalOnAcountFreight = 0
        let AllTotalFocSelfFreight = 0
        let AllTotalDddvFreight = 0
        let AllTotalFreight = 0
        let AllTotalToPayCodGstOth = 0
        let AllPaidGstOthe = 0
        let AllTotalOnAcountGstOth = 0
        let AllTotalFocSelfGstOth = 0
        let AllTotalDddvGstOth = 0
        let AllTotalGstOth = 0
        let AllTotalValuation = 0
        let AllTotalOtherCharges = 0
        let AllTotalLrs = 0
        let AllTotalNetAmount = 0
        totalDatatwo?.map((val) => {
          TopayCodunitTotal += Number(val.TopayUnit)
          PaidunitTotal += Number(val.PaidUnit)
          OnActunitTotal += Number(val.OnAccountUnit)
          FocSelfunitTotal += Number(val.FocAndSelfUnit)
          DDDVunitTotal += Number(val.DDDVUnit)
          NetunitTotal += Number(val.TotalUnits)
          AllTotalToPayCodFreight += Number(val.TopayFreight)
          AllPaidFreight += Number(val.PaidFreight)
          AllTotalOnAcountFreight += Number(val.OnAccountFreight)
          AllTotalFocSelfFreight += Number(val.FocAndSelfFreight)
          AllTotalDddvFreight += Number(val.DDDVFreight)
          AllTotalFreight += Number(val.TotalFreight)
          AllTotalToPayCodGstOth += Number(val.TopayCodGstOth)
          AllPaidGstOthe += Number(val.PaidGstOth)
          AllTotalOnAcountGstOth += Number(val.OnActGstOth)
          AllTotalFocSelfGstOth += Number(val.FOCSelfGstOth)
          AllTotalDddvGstOth += Number(val.DDDVGstOth)
          AllTotalGstOth += Number(val.NetOther)
          AllTotalValuation += Number(val.Insurance)
          AllTotalOtherCharges += Number(val.OtherCharge)
          AllTotalLrs += Number(val.TotalLRCount)
          AllTotalNetAmount += Number(val.TotalNetAmount)
        })
        totalDatatwo.push({
          Station: 'TOTAL AMOUNT',
          TopayUnit: TopayCodunitTotal,
          PaidUnit: PaidunitTotal,
          OnAccountUnit: OnActunitTotal,
          FocAndSelfUnit: FocSelfunitTotal,
          DDDVUnit: DDDVunitTotal,
          TotalUnits: NetunitTotal,
          TopayFreight: AllTotalToPayCodFreight,
          PaidFreight: AllPaidFreight,
          OnAccountFreight: AllTotalOnAcountFreight,
          FocAndSelfFreight: AllTotalFocSelfFreight,
          DDDVFreight: AllTotalDddvFreight,
          TotalFreight: AllTotalFreight,
          TopayCodGstOth: AllTotalToPayCodGstOth,
          PaidGstOth: AllPaidGstOthe,
          OnActGstOth: AllTotalOnAcountGstOth,
          FOCSelfGstOth: AllTotalFocSelfGstOth,
          DDDVGstOth: AllTotalDddvGstOth,
          NetOther: AllTotalGstOth,
          Insurance: AllTotalValuation,
          OtherCharge: AllTotalOtherCharges,
          TotalLRCount: AllTotalLrs,
          TotalNetAmount: AllTotalNetAmount,
        })
        setTableData(totalDatatwo)
      } else {
        setTableData([])
      }
    }else if (detailedFilter?.Name === 'Vehicle Wise Dispatch') {
      if (dispatchSummaryTableData?.Data?.Table2?.length > 0) {
       // const totalDataTableOne = dispatchSummaryTableData?.Data?.Table2
        const totalDatatwo = dispatchSummaryTableData?.Data?.Table2?.map((val, index) => ({
          ...val,
          SN: index + 1,
          DispatchDateTime: val?.DispatchDateTime === "" ? '' : moment(val?.DispatchDateTime).format('DD/MM/YY,HH:mm')
        }))
        let PaidunitTotal = 0
        let TopayCodunitTotal = 0
        let OnActunitTotal = 0
        let FocSelfunitTotal = 0
        let TotalunitTotal = 0
        let PaidAmtTotal = 0
        let TopayAmtTotal = 0
        let OnActAmtTotal = 0
        let FocSelfAmtTotal = 0
        let TotalAmtTotal = 0

        totalDatatwo?.map((val) => {
          PaidunitTotal += Number(val.PaidUnit);
          TopayCodunitTotal += Number(val.TopayUnit);
          OnActunitTotal += Number(val.OnAccountUnit);
          FocSelfunitTotal += Number(val.FocAndSelfUnit);
          TotalunitTotal += Number(val.TotalUnits);
          PaidAmtTotal += Number(val.PaidTotal);
          TopayAmtTotal += Number(val.ToPayTotal);
          OnActAmtTotal += Number(val.OnAccountTotal);
          FocSelfAmtTotal += Number(val.FOCTotal);
          TotalAmtTotal += Number(val.TotalNetAmount);
        });
        
        // Add rounded totals to the array
        totalDatatwo.push({
          isTotal: true,
          SN: 'TOTAL AMOUNT',
          PaidUnit: PaidunitTotal.toFixed(2),
          TopayUnit: TopayCodunitTotal.toFixed(2),
          OnAccountUnit: OnActunitTotal.toFixed(2),
          FocAndSelfUnit: FocSelfunitTotal.toFixed(2),
          TotalUnits: TotalunitTotal.toFixed(2),
          PaidTotal: PaidAmtTotal.toFixed(2),
          ToPayTotal: TopayAmtTotal.toFixed(2),
          OnAccountTotal: OnActAmtTotal.toFixed(2),
          FOCTotal: FocSelfAmtTotal.toFixed(2),
          TotalNetAmount: TotalAmtTotal.toFixed(2),
        });
        
        setTableData(totalDatatwo)//totalDatatwo
      } else {
        setTableData([])
      }
    } else if (detailedFilter?.Name === 'Other Charges') {
      if (dispatchSummaryTableData?.Data?.Table1?.length > 0) {
        const totalDataTableOne = dispatchSummaryTableData?.Data?.Table1?.map((val, index) => ({
          ...val, srNo: index + 1,
          TotalPaid: val.PaidFreight + val.PaidOther + val.PaidGST,
          TotalToPay: val.TopayFreight + val.TopayOther + val.TopayGST,
          TotalToPayDDDV: val.DDDVFreight + val.DDDVOther + val.DDDVGST
        }))
        const totalDatatwo = totalDataTableOne?.map((val) => ({
          ...val,
          NetAmount: val.TotalNetAmount
        }))
        let TotalUnits = 0
        let PaidFreight = 0
        let TopayFreight = 0
        let DDDVFreight = 0
        let PaidOther = 0
        let TopayOther = 0
        let DDDVOther = 0
        let PaidGST = 0
        let TopayGST = 0
        let DDDVGST = 0
        let TotalPaid = 0
        let TotalToPay = 0
        let TotalToPayDDDV = 0
        let NetAmount = 0
        totalDatatwo?.map((val) => {
          TotalUnits += Number(val.TotalUnits)
          PaidFreight += Number(val.PaidFreight)
          TopayFreight += Number(val.TopayFreight)
          DDDVFreight += Number(val.DDDVFreight)
          PaidOther += Number(val.PaidOther)
          TopayOther += Number(val.TopayOther)
          DDDVOther += Number(val.DDDVOther)
          PaidGST += Number(val.PaidGST)
          TopayGST += Number(val.TopayGST)
          DDDVGST += Number(val.DDDVGST)
          TotalPaid += Number(val.TotalPaid)
          TotalToPay += Number(val.TotalToPay)
          TotalToPayDDDV += Number(val.TotalToPayDDDV)
          NetAmount += Number(val.NetAmount)
        })
        totalDatatwo.push({
          srNo: 'TOTAL AMOUNT',
          TotalUnits: TotalUnits,
          PaidFreight: PaidFreight,
          TopayFreight: TopayFreight,
          DDDVFreight: DDDVFreight,
          PaidOther: PaidOther,
          TopayOther: TopayOther,
          DDDVOther: DDDVOther,
          PaidGST: PaidGST,
          TopayGST: TopayGST,
          DDDVGST: DDDVGST,
          TotalPaid: TotalPaid,
          TotalToPay: TotalToPay,
          TotalToPayDDDV: TotalToPayDDDV,
          NetAmount: NetAmount,
          isTotal: true
        })
        setTableData(totalDatatwo)
      } else {
        setTableData([])
      }
    }

  }, [dispatchSummaryTableData])
  return (
    <>
      <div
        className="print-input-btn"
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'end', padding: '12px 16px', width: '100%', marginBottom: '-10px' }}
      >
        {showTable ? (
          <>
            <Box style={{ display: 'flex', width: '100%', height: '32px', padding: '12px 0px', marginRight: '0px' }}>
              <Box
                style={{ display: 'flex', width: '50%', justifyContent: 'flex-start', alignItems: 'center', gap: '12px', fontSize: '14px' }}
              >
                <h3 style={{ textAlign: 'left', color: '#444' }}>
                  {showSummaryReport?.Name} View - {detailedFilter?.Name}
                </h3>
                {showSummaryReport.id === 1 && detailedFilter.id === 0 && (
                  <Box
                    style={{
                      height: '32px',
                      display: 'flex',
                      padding: '8px 12px',
                      justifycontent: 'center',
                      alignitems: 'center',
                      gap: '6px',
                    }}
                    id="dispatchReportManageColumn"
                    tabIndex={0}
                    onClick={() => updateModal(true, 'showManageColumn')}
                  >
                    <span tabIndex={0} style={{ display: 'flex', margin: '-3px' }}>
                      <AppsIcon />
                    </span>
                    <span tabIndex={0} style={{ fontWeight: 'bold' }}>
                      MANAGE COLUMNS
                    </span>
                  </Box>
                )}
                {detailedFilter?.Name === 'With Other Charges' ? <h3>*(#)=Units</h3> : ''}
              </Box>
              <Box
                style={{
                  display: 'flex',
                  width: '50%',
                  justifyContent: 'end',
                  alignItems: 'center',
                }}
              >
                <Grid item xs={6} md={2}>
                  <Button
                    id='DispatchPrintBtn'
                    startIcon={<PrintIcon />}
                    variant="contained"
                    color="primary"
                    style={{ ...transparentStyle(theme), fontSize: '100%' }}
                    onClick={() => {
                      setShowTable(false)
                      if (tableData?.length > 1000) {
                        setLargePDF(true)
                      } else {
                        printClick(false)
                      }
                    }}
                    onKeyDown={(e) => navigation3(e, disableExcel ? "DispatchPdfBtn" : "xls-button-dispatch", "generateBtn", () => { setShowTable(false); tableData?.length > 1000 ? setLargePDF(true) : printClick(false) })}
                  >
                    Print
                  </Button>
                </Grid>
                <Divider
                  orientation="vertical"
                  flexItem
                  style={{ width: '2px', margin: '0', height: '15px', alignSelf: 'center', backgroundColor: '#ccc' }}
                />
                {
                  disableExcel ? null
                    //   <Grid item xs={6} md={2}>
                    //   <Button
                    //   variant="outlined"
                    //   sx={{ width: '100%',opacity:"0.5",border }}
                    //   className="receiveitembtn"
                    //   disabled={true}
                    // >
                    //   Export to Excel
                    // </Button>
                    // </Grid>
                    : <Grid item xs={6} md={2}>
                      <Box >
                        <Button
                          onKeyDown={(e) => navigation3(e, 'DispatchPdfBtn', 'DispatchPrintBtn', () => { })}
                          id='xls-button-dispatch'
                          startIcon={<ExcelIcon />}
                          variant="contained"
                          color="primary"
                          style={{ ...transparentStyle(theme), fontSize: '100%', }}
                          onClick={(e) => { clickElement('xls-buttons-dispatch') }}
                        >
                          EXPORT AS EXCEL
                        </Button>
                        <ReactHtmlTableToExcel
                          id="xls-buttons-dispatch"
                          table="tables"
                          filename={`Dispatch Report ${currentDateTime}`}
                          sheet="sheet 1"
                          buttonText="EXPORT AS EXCEL"
                          className="excel-button"
                        />
                      </Box>
                    </Grid>
                }

                <Divider
                  orientation="vertical"
                  flexItem
                  style={{ width: '2px', margin: '0', height: '15px', alignSelf: 'center', backgroundColor: '#ccc' }}
                />
                <Button
                  id='DispatchPdfBtn'
                  startIcon={<PdfIcon />}
                  variant="contained"
                  color="primary"
                  style={{ ...transparentStyle(theme), fontSize: '100%' }}
                  onClick={() => {
                    setShowTable(false)
                    if (tableData?.length > 1000) {
                      setLargePDF(true)
                    } else {
                      printClick(true)
                    }
                  }}
                  onKeyDown={(e) => navigation3(e, 'fromDate', "xls-button-dispatch", () => { setShowTable(false); tableData?.length > 1000 ? setLargePDF(true) : printClick(false) })}
                >
                  Export as PDF
                </Button>
              </Box>
            </Box>
          </>
        ) : (
          <>
            <Box className="export-as-pdf" style={{ paddingTop: '7px' }}>
              <Button
                id='DispatchBackBtn'
                variant="contained"
                onClick={() => { setShowTable(true); setLargePDF(false) }}
                onKeyDown={(e) => navigation3(e, 'fromDate', 'generateBtn', () => { setShowTable(true); setLargePDF(false); focusElemnt('generateBtn') })}
                style={{ borderRadius: '5px', fontWeight: 'bold', cursor: 'pointer', fontSize: '15px', color: '#fe5200', background: 'white', marginLeft: '10px', border: '2px solid #fe5200' }}
              >
                BACK
              </Button>
            </Box>
          </>
        )}
      </div>
      {showTable ? (
        <>
          {getTable(tableindex, tableData, manageColumn)}
        </>
      ) : (
        <>
          {largePDF ? (
            showSummaryReport?.id === 0 && detailedFilter?.id === 0 ? (
              <WithVehicleAndChartDateSummaryLargePdf
                tableData={tableData}
                toDate={toDate}
                fromDate={fromDate}
                detailedFilter={detailedFilter}
                headerData={headerData}
              />
            ) : showSummaryReport?.id === 0 && detailedFilter?.id === 1 ? (
              <WithHamaliAndChartageSummaryLargePdf
                tableData={tableData}
                toDate={toDate}
                fromDate={fromDate}
                detailedFilter={detailedFilter}
                headerData={headerData}
              />
            ) : showSummaryReport?.id === 0 && detailedFilter?.id === 2 ? (
              <WithOtherChargeSummaryLargePdf
                tableData={tableData}
                toDate={toDate}
                fromDate={fromDate}
                detailedFilter={detailedFilter}
                headerData={headerData}
              />
            ) : showSummaryReport?.id === 0 && detailedFilter?.id === 3 ? (
              <BranchSummaryLargePdf
                tableData={tableData}
                toDate={toDate}
                fromDate={fromDate}
                detailedFilter={detailedFilter}
                headerData={headerData}
              />
            ) : showSummaryReport?.id === 1 && detailedFilter?.id === 0 ? (
              <VehicleWiseDispatchDetailedLargePdf
                paymentWiseTotal={paymentWiseTotal}
                tableData={tableData}
                toDate={toDate}
                fromDate={fromDate}
                detailedFilter={detailedFilter}
                headerData={headerData}
              />
            ) : showSummaryReport?.id === 1 && detailedFilter?.id === 1 ? (
              <WithVehicleAndChartDateDetailedLargePdf
                groupDataSecond={groupDataSecond}
                toDate={toDate}
                fromDate={fromDate}
                detailedFilter={detailedFilter}
                headerData={headerData}
              />
            ) : showSummaryReport?.id === 1 && detailedFilter?.id === 2 ? (
              <WithPaymentTypeGroupLargePdf
                tableData={tableData}
                toDate={toDate}
                fromDate={fromDate}
                detailedFilter={detailedFilter}
                headerData={headerData}
              />
            ) : showSummaryReport?.id === 1 && detailedFilter?.id === 3 ? (
              <ShowOnlyToPayAmountDetailedLargePdf
                paymentSummary={paymentSummary}
                paymentWiseVehicleData={paymentWiseVehicleData}
                toDate={toDate}
                fromDate={fromDate}
                detailedFilter={detailedFilter}
                headerData={headerData}
              />
            ) : (
              ''
            )
          ) : (
            <>
              {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
              {load ? (
                <Box sx={{ ...sx.reportFlex, justifyContent: 'center' }}>
                  <object
                    id="Reportoutput"
                    type="application/pdf"
                    width="100%"
                    height="440"
                    title="MTLPL -Cargo System - After Transfer Summary Report"
                    aria-label="MTLPL -Cargo System - After Transfer Summary Report"
                  ></object>
                </Box>
              ) : (
                ''
              )}
            </>
          )}
        </>
      )}
    </>
  )
}
const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
  updateModal,
}

export default connect(mapStateToProps, mapDispatchToProps)(DispatchReportTable)
